import React from "react";
import { Button } from "react-bootstrap";

export default ({
  isLoading,
  text = "Guardar",
  loadingText = "Guardando...",
  iconBefore,
  iconAfter,
  className = "",
  disabled = false,
  block = false,
  ...props
}) =>
  <Button
    className={`SubmitButton ${className} ${block ? "btn-block" : ""}`}
    disabled={disabled || isLoading}
    {...props}
  >
    {!isLoading && iconBefore && iconBefore}
    {!isLoading ? text : loadingText}
    {!isLoading && iconAfter && iconAfter}
  </Button>;
